import { Button, Stack, Text, Textarea, TextInput } from '@mantine/core';
import { useForm } from '@mantine/form';
import { IconSend } from '@tabler/icons-react';
import { useRequest } from 'ahooks';
import { zodResolver } from 'mantine-form-zod-resolver';
import { z } from 'zod';

interface SignatureRequestFormValues extends Record<string, unknown> {
  name: string;
  customText: string;
}

interface SignatureRequestFormProps {
  onSubmit: (values: { name: string; customText: string }) => Promise<void>;
  defaultName?: string;
  recipient: string;
}

export function SignatureRequestForm({
  onSubmit,
  recipient,
  defaultName,
}: SignatureRequestFormProps) {
  const form = useForm<SignatureRequestFormValues>({
    initialValues: {
      name: defaultName || '',
      customText:
        'Nous sommes heureux que vous nous accordiez votre confiance.\nMerci de suivre les informations indiquées…',
    },
    validate: zodResolver(
      z.object({
        name: z.string().min(1, { message: 'Nom de la demande requis' }),
      }),
    ),
  });

  const { run: handleSubmit, loading: isSubmitting } = useRequest(
    async (values: SignatureRequestFormValues) => {
      await onSubmit({
        name: values.name,
        customText: values.customText,
      });
    },
    { manual: true },
  );

  return (
    <form onSubmit={form.onSubmit(handleSubmit)}>
      <Stack>
        {/* Need to import Text from @mantine/core */}
        <Text>
          Vous êtes sur le point d'envoyer ce document pour signature à :<br />
        </Text>
        <Text span fw={800}>
          {recipient}
        </Text>
        <TextInput
          label="Nom de la demande de signature"
          placeholder="Exemple : Offre Maison principal"
          required
          {...form.getInputProps('name')}
        />
        <Textarea
          autosize
          minRows={6}
          maxRows={10}
          required
          label="Texte personnalisé"
          rows={6}
          {...form.getInputProps('customText')}
        />
        <Button
          type="submit"
          loading={isSubmitting}
          leftSection={<IconSend size={16} />}
        >
          Envoyer la demande
        </Button>
      </Stack>
    </form>
  );
}
